










































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import Telefono from "../../models/telefono.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Helpers from "@/helpers/helper";
import { SolicitudEvaluacionHogarMiembro } from "../../models/tramite/solicitud-evaluacion-hogar";

@Component({})
export default class SolicitudEvaluacionHogarResumen extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  model: any = null;
  telefonoTableConfig!: BTableConfig<Telefono>;
  miembroTableConfig!: BTableConfig<SolicitudEvaluacionHogarMiembro>;
  constructor() {
    super();
    this.telefonoTableConfig = new BTableConfig<Telefono>();
    this.miembroTableConfig = new BTableConfig<
      SolicitudEvaluacionHogarMiembro
    >();
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }
  get tramiteBeneficiarioId() {
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }
  get correos() {
    if (this.model && this.model.correos) {
      return this.model.correos.split(";");
    }
    return [];
  }
  get formaCoccionAlimentos() {
    if (this.model && this.model.formaCoccionAlimentos.length > 0)
      return this.model.formaCoccionAlimentos.filter(
        (x: any) => x.nameValueNombre !== "Otro"
      );
    return [];
  }
  get esReevaluacion() {
    if (this.model) return this.model.esReevaluacion;
    return false;
  }

  getPersona(
    id: number,
    nombre: string,
    cedula: string,
    foto: string,
    model: Persona
  ) {
    let persona = model || new Persona();
    persona.id = id;
    persona.nombreCompleto = nombre;
    persona.cedula = cedula;
    persona.foto = foto;
    return persona;
  }
  created() {
    this.setupTableMiembro();
  }
  setupTableMiembro() {
    this.miembroTableConfig.controller = "SolicitudEvaluacionHogarMiembro";
    this.miembroTableConfig.include = "Persona|Parentesco|RazonInclusion";
    this.miembroTableConfig.activeActions = false;
    this.miembroTableConfig.detailed = true;
    this.miembroTableConfig.whereParams = `SolicitudEvaluacionHogar.TramiteBeneficiarioId="${this.tramiteBeneficiarioId}"`;
    let persona = new BTableColumn(
      "personaId",
      this.isMobile ? "Nombre" : "Nombre completo"
    );
    persona.customTemplate = true;
    persona.templateSlot = "persona";
    let edad = new BTableColumn("persona.fechaNacimiento", "Edad");
    edad.customTemplate = true;
    edad.templateSlot = "column-edad";
    let parentesco = new BTableColumn("parentescoNombre", "Parentesco", false);
    let sexo = new BTableColumn("persona.sexo", "Genero");
    sexo.type = BTableColumnType.Custom;
    sexo.customFilter = Helpers.Filters.Sexo;
    let razon = new BTableColumn(
      "razonInclusionNombre",
      "Razón de inclusión",
      false
    );
    this.miembroTableConfig.insertColumns(
      persona,
      edad,
      parentesco,
      sexo,
      razon
    );
  }
  setupTableTelefono() {
    this.telefonoTableConfig.activeActions = false;
    this.telefonoTableConfig.controller = "Telefono";
    this.telefonoTableConfig.include = "TipoTelefono";
    let tel = new BTableColumn("numero", "Teléfono");
    tel.customTemplate = true;
    this.telefonoTableConfig.insertColumns(tel);
    this.telefonoTableConfig.whereParams = `SolicitudEvaluacionHogarId="${this.model.id}"`;
  }
  async mounted() {
    if (this.tramiteBeneficiarioId) {
      this.model = await new BaseHttpClient(
        "TramiteBeneficiarioResumen"
      ).getAsync("GetSolicitudEvaluacionHogar", {
        tramiteId: this.tramiteBeneficiarioId
      });
      this.setupTableTelefono();
    }
  }
}
